import React, { useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetInterserviceDropdownListQuery } from '../../../../../../../api';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';

export const InterserviceDropdown = ({ value, onChange, className, selectType }) => {
    const { th } = useLanguage();

    const { data, isLoading } = useGetInterserviceDropdownListQuery(selectType, { skip: !selectType }); // );

    const options =
        data?.data?.map((opt) => ({
            id: opt.id,
            label: opt.fullName
        })) || [];

    return (
        <Dropdown
            optionValue="id"
            value={value}
            options={options}
            onChange={(e) => onChange(e.value)}
            optionLabel="label"
            disabled={!selectType}
            placeholder={th('customerAddressBrand.tabs.addrReport.placeholder.selectService')}
            loading={isLoading}
            className={className}
            showClear
            filter
        />
    );
};
